// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609071634/js/" + chunkId + "." + {"44":"ee599667","225":"d7a66c96","481":"06425d3d","486":"2ee9c4e9","770":"aac881b9"}[chunkId] + ".0.5893456643956378.chunk.js";
};